var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoSmallTile"},[_c('div',{class:[
      'infoSmallTile__wrapper',
      { 'infoSmallTile__wrapper--isBanner': _vm.isBanner },
      { 'infoSmallTile__wrapper--centerContent': _vm.centerContent },
    ]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }